import React from 'react';
import Grow from '@material-ui/core/Grow';
import { withStyles } from '@material-ui/core/styles';
import styled, { ThemeProvider } from 'styled-components';
import { themeVia } from '../../styledComponents/settings/theme';
import TextInput from '../../styledComponents/styles/TextInput.styled';

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this,
      args = arguments;
    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

const InputDiv = styled.div`
  width: 400px;
`;

const MainDiv = styled.div`
  display: flex;
  flex: 1 0 auto;
  align-items: center;
`;

const defaultStyles = theme => ({});

class _DebounceTableSearch extends React.Component {
  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  onKeyDown = event => {
    if (event.keyCode === 27) {
      this.props.onHide();
    }
  };

  handleTextChangeWrapper = debouncedSearch => event => {
    debouncedSearch(event.target.value);
  };

  render() {
    const { classes, options, onHide, searchText, debounceWait, label } = this.props;

    const debouncedSearch = debounce(value => {
      this.props.onSearch(value);
    }, debounceWait);

    return (
      <ThemeProvider theme={themeVia}>
        <Grow appear in timeout={300}>
          <MainDiv>
            <InputDiv style={this.props?.styles || {}}>
              <TextInput
                id={'textSearch'}
                icon={'Search'}
                label={label}
                className={classes.searchText}
                autoFocus={true}
                defaultValue={searchText}
                onChange={this.handleTextChangeWrapper(debouncedSearch)}
                placeholder={options.searchPlaceholder}
                openSans
                {...(options.searchProps || {})}
              />
            </InputDiv>
          </MainDiv>
        </Grow>
      </ThemeProvider>
    );
  }
}

let DebounceTableSearch = withStyles(defaultStyles, { name: 'MUIDataTableSearch' })(_DebounceTableSearch);
export { DebounceTableSearch };

export function debounceSearchRenderDashboard(debounceWait = 200, label = '', styles = {}) {
  return (searchText, handleSearch, hideSearch, options) => {
    return (
      <DebounceTableSearch
        searchText={searchText}
        onSearch={handleSearch}
        onHide={hideSearch}
        options={options}
        debounceWait={debounceWait}
        label={label}
        styles={styles}
      />
    );
  };
}

export const DEBOUNCE_VALUE = 500;
